import layout from '@/layout'

export default {
  path: '/sys',
  component: layout,
  redirect: '/sys/account',
  name: 'platAccount',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: '/sys/account',
      redirect: '/sys/account/plat',
      meta: {
        title: '平台账号管理',
        icon: 'people'
      },
      children: [
        {
          path: '/sys/account/plat',
          component: () => import('@/views/sys/plat-account'),
          meta: {
            title: '平台账号管理',
            icon: 'user'
          }
        }
      ]
    }
  ]
}
